export const GET_POSTS_REQUEST = "POST.GET_POSTS_REQUEST";
export const GET_POSTS_SUCCESS = "POST.GET_POSTS_SUCCESS";
export const GET_POSTS_FAILURE = "POST.GET_POSTS_FAILURE";

export const GET_SINGLE_POST_REQUEST = "POST.GET_SINGLE_POST_REQUEST";
export const GET_SINGLE_POST_SUCCESS = "POST.GET_SINGLE_POST_SUCCESS";
export const GET_SINGLE_POST_FAILURE = "POST.GET_SINGLE_POST_FAILURE";

export const GET_POSTS_BY_DOCTOR_REQUEST = "POST.GET_POSTS_BY_DOCTOR_REQUEST";
export const GET_POSTS_BY_DOCTOR_SUCCESS = "POST.GET_POSTS_BY_DOCTOR_SUCCESS";
export const GET_POSTS_BY_DOCTOR_FAILURE = "POST.GET_POSTS_BY_DOCTOR_FAILURE";

export const CREATE_COMMENT_REQUEST = "POST.CREATE_COMMENT_REQUEST";
export const CREATE_COMMENT_SUCCESS = "POST.CREATE_COMMENT_SUCCESS";
export const CREATE_COMMENT_FAILURE = "POST.CREATE_COMMENT_FAILURE";

export const CREATE_REACTION_REQUEST = "POST.CREATE_REACTION_REQUEST";
export const CREATE_REACTION_SUCCESS = "POST.CREATE_REACTION_SUCCESS";
export const CREATE_REACTION_FAILURE = "POST.CREATE_REACTION_FAILURE";

export const GET_SUB_CATEGORIES_REQUEST = "POST.GET_SUB_CATEGORIES_REQUEST";
export const GET_SUB_CATEGORIES_SUCCESS = "POST.GET_SUB_CATEGORIES_SUCCESS";
export const GET_SUB_CATEGORIES_FAILURE = "POST.GET_SUB_CATEGORIES_FAILURE";

export const CREATE_POST_REQUEST = "POST.CREATE_POST_REQUEST";
export const CREATE_POST_SUCCESS = "POST.CREATE_POST_SUCCESS";
export const CREATE_POST_FAILURE = "POST.CREATE_POST_FAILURE";

export const GET_POSTS_BY_CATEGORY_REQUEST =
  "POST.GET_POSTS_BY_CATEGORY_REQUEST";
export const GET_POSTS_BY_CATEGORY_SUCCESS =
  "POST.GET_POSTS_BY_CATEGORY_SUCCESS";
export const GET_POSTS_BY_CATEGORY_FAILURE =
  "POST.GET_POSTS_BY_CATEGORY_FAILURE";
